import React, { createContext, useContext, useState } from 'react';

const HelpContext = createContext(null);

export const HelpProvider = ({ children }) => {
  const [activeVideo, setActiveVideo] = useState(null); // { id, title, description }
  const [isMinimized, setIsMinimized] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Guided tour state
  const [isTourRunning, setIsTourRunning] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  const playVideo = (video) => {
    setActiveVideo(video);
    setIsMinimized(false);
    setIsFullscreen(false);
  };

  const closeVideo = () => {
    setActiveVideo(null);
    setIsMinimized(false);
    setIsFullscreen(false);
  };

  const minimizeVideo = () => {
    setIsMinimized(true);
    setIsFullscreen(false);
  };

  const maximizeVideo = () => {
    setIsMinimized(false);
  };

  const toggleFullscreen = () => {
    setIsFullscreen((prev) => !prev);
    setIsMinimized(false);
  };

  const startTour = () => { setTourKey(k => k + 1); setIsTourRunning(true); };
  const stopTour = () => setIsTourRunning(false);

  return (
    <HelpContext.Provider
      value={{
        activeVideo,
        isMinimized,
        isFullscreen,
        playVideo,
        closeVideo,
        minimizeVideo,
        maximizeVideo,
        toggleFullscreen,
        isTourRunning,
        tourKey,
        startTour,
        stopTour,
      }}
    >
      {children}
    </HelpContext.Provider>
  );
};

export const useHelp = () => {
  const ctx = useContext(HelpContext);
  if (!ctx) throw new Error('useHelp must be used inside HelpProvider');
  return ctx;
};
